import axios from '../utils/axios';

export default function fetchManagedRecruiters(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/managed-recruiters', { params })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            })
    )
}